var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#85D1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 30.5V23.7846C20.8333 23.2764 20.8333 23.0223 20.9302 22.8281C21.0154 22.6574 21.1514 22.5186 21.3187 22.4316C21.5088 22.3327 21.7577 22.3327 22.2556 22.3327H24.7444C25.2423 22.3327 25.4912 22.3327 25.6813 22.4316C25.8486 22.5186 25.9846 22.6574 26.0698 22.8281C26.1667 23.0223 26.1667 23.2764 26.1667 23.7846V30.5M22.6268 13.9512L16.5981 18.7382C16.1951 19.0582 15.9936 19.2182 15.8485 19.4186C15.7199 19.5961 15.6241 19.7961 15.5658 20.0087C15.5 20.2487 15.5 20.5093 15.5 21.0305V27.5961C15.5 28.6125 15.5 29.1208 15.6938 29.509C15.8642 29.8505 16.1362 30.1282 16.4707 30.3022C16.851 30.5 17.3488 30.5 18.3444 30.5H28.6556C29.6512 30.5 30.149 30.5 30.5293 30.3022C30.8638 30.1282 31.1358 29.8505 31.3062 29.509C31.5 29.1208 31.5 28.6125 31.5 27.5961V21.0305C31.5 20.5093 31.5 20.2487 31.4342 20.0087C31.3759 19.7961 31.2801 19.5961 31.1515 19.4186C31.0064 19.2182 30.8049 19.0582 30.4019 18.7382L24.3732 13.9512C24.0609 13.7032 23.9047 13.5792 23.7323 13.5315C23.5802 13.4895 23.4198 13.4895 23.2677 13.5315C23.0953 13.5792 22.9391 13.7032 22.6268 13.9512Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHome);
export default __webpack_public_path__ + "static/media/active-home.49466266c340b6e2abb6a203428e381f.svg";
export { ForwardRef as ReactComponent };